import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from '../../components/StatsTable';
import Graph from './components/Graph';
import API from '../../services/API';
import { PARAMS_NAME, NAN_PARAMS } from "./config";

class AdkDaily extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            partnerValues: [],
            params: [],
            paramsObj: {},
            report: [],
            graph: [],
            total: {},
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadPartners();
        this.loadAffids();

        const date = new Date();
        const dateTo = date.toISOString().split('T')[0];

        date.setDate(date.getDate() - 8);

        const dateFrom = date.toISOString().split('T')[0];

        this.setState({ isLoading: true });

        API.AdkReport.get('daily', { dateFrom, dateTo }, 'graph').then(({ graph }) =>
            this.setState({ graph, isLoading: false }));
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadAffids() {
        API.AdkFeeds.getIds()
            .then(affids => this.setState({ affidValues: affids }));
    }

    loadPartners() {
        API.AdkPartners.get().then(partners => {
            partners = partners.reduce((obj, { id, name }) => {
                obj[id] = name;

                return obj;
            }, {});

            this.setState({ partnerValues: partners })
        });
    }

    loadReport(filters, type) {
        Promise.all([
            API.AdkReport.get('daily', filters, type),
            API.AdkReport.get('daily', filters, 'graph')
        ]).then(([ { params, report, total }, { graph } ]) => {
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, graph, total, isLoading: false };

            this.setState(newState)
        })
    }

    loadSubids(filters) {
        API.AdkReport.get('daily', filters, 'subid').then(({ subids }) => {
            this.setState({ isLoading: false,  subidValues: subids })
        });
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return <Graph data={graph} />;
    }

    render() {
        const { isLoading, affidValues, subidValues, params, paramsObj, report, total } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="ADK Daily V3"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues} partnerValues={this.state.partnerValues}/>

                {this.getGraph()}

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        );
    }
}

export default AdkDaily;



// WEBPACK FOOTER //
// ./src/scenes/AdkDailyV3/index.js